import { SubscriptionClient } from 'subscriptions-transport-ws';
import ws from 'isomorphic-ws';

import { LYSTER_API_ENDPOINT } from '../env';


export const options = {
  reconnect: true,
  reconnectionAttempts: 50,
  lazy: true,
  timeout: 20000,
  inactivityTimeout: 20000,
};

export const uri = `${LYSTER_API_ENDPOINT}graphql`.replace(/(http):\/\//, 'ws://').replace(/(https):\/\//, 'wss://');

export default new SubscriptionClient(uri, options, ws);
